// extracted by mini-css-extract-plugin
export default {"container":"StakingPositions_container__1DsTo"};